export default __webpack_public_path__ + "static/media/Shoppywhite.3ae7bf1e.svg";